import BaseModel from '../BaseModel';
import Edge from './Edge';
import PageInfo from './PageInfo';

export default class BaseConnection extends BaseModel {
  constructor(connectionType, modelType, data = {}) {
    super(connectionType, data);
    this.edges = (data.edges || []).map(
      (edge) => new Edge(connectionType, modelType, edge)
    );
    this.pageInfo = new PageInfo(data.pageInfo);
  }

  nodes() {
    return this.edges.map((edge) => edge.node);
  }
}
